import './RedeemActionButtons.css';

/**
 * Action buttons component for redeemable games
 * Displays Redeem button with proper state management
 */
function RedeemActionButtons({ redeemState, onRedeem }) {
  return (
    <button
      type="button"
      className={`redeem-action-button ${
        redeemState.enabled ? 'redeem-action-button--enabled' : 'redeem-action-button--disabled'
      }`}
      onClick={onRedeem}
      disabled={!redeemState.enabled}
      title={redeemState.reason}
    >
      {redeemState.text}
    </button>
  );
}

export default RedeemActionButtons;
